import moment from "moment";
import { apiClient, createSuccessResponse, handleApiError } from "./api";

const availabilityService = {
  async findPanels(data, dtIni, dtFim, qtdInsercao) {
    try {
      var dados = {
        id: data,
        dtStart: dtIni,
        dtEnd: dtFim,
        vlInsert: qtdInsercao,
      };

      console.log(dados);

      var retorno = await apiClient.post("/availability/findid", dados);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },

  async findItemsByPanel(data, dtIni, dtFim, qtdInsercao) {
    try {
      var dados = {
        id: data,
        dtStart: dtIni,
        dtEnd: dtFim,
        vlInsert: qtdInsercao,
      };

      console.log(dados);

      var retorno = await apiClient.post("/availability/findPanelName", dados);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },

  async findBudget(idbudget) {
    try {
      var retorno = await apiClient.get("/budget/" + idbudget);

      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },

  async createBuget(data) {
    try {
      console.log(data);

      var retorno = await apiClient.post("/budget", data);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },

  async editarBuget(data) {
    try {
      console.log(data);

      var retorno = await apiClient.put("/budget", data);

      return createSuccessResponse(retorno.data, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },

  async findAll(data) {
    try {
      const arrayData = ([] = []);

      var date1 = new Date(data.dtini);
      var date2 = new Date(data.dtFim);

      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      for (let index = 1; index <= diffDays + 1; index++) {
        // const stringdate = '2023-01-01T00:00:00-03:00';
        const data1 = new Date(data.dtini);
        data1.setDate(data1.getDate() + index);

        let datess = moment(data1).format("YYYY-MM-DD");
        // console.log(datess)
        arrayData.push(datess);
      }

      var panelData = [];
      data.panel.forEach((item) => {
        panelData.push({
          idpanel: item,
          dates: arrayData,
        });
      });

      // console.log(panelData)
      var retorno = await apiClient.post("/availability", panelData);
      // console.log(retorno)
      return retorno.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
    }
  },
};

export default availabilityService;
